import { render, staticRenderFns } from "./TextTemplates.yaml?vue&type=template&id=953c5c1e&component"
import script from "./TextTemplates.yaml?vue&type=script&lang=ts&component"
export * from "./TextTemplates.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports